export function formatFormValuesFromCsatPreview(values) {
    return {
        followup_question: values.rating_follow_up_question,
        followup_question_placeholder_text: values.rating_placeholder_text,
        rating_question: values.rating_question,
        rating_type: values.look_and_feel,
        thank_you_message: values.rating_completed_message,
    };
}
